export const WALLET_AMOUNT_MIN_RUB = 100;
export const WALLET_AMOUNT_MAX_RUB = 100_000;

export function roundWalletAmountRub(value: number): number {
  return Math.round(value * 100) / 100;
}

export function clampWalletAmountRub(value: number): number {
  return roundWalletAmountRub(
    Math.min(WALLET_AMOUNT_MAX_RUB, Math.max(WALLET_AMOUNT_MIN_RUB, value)),
  );
}

export function validateWalletAmountRub(value: number): string | null {
  if (!Number.isFinite(value)) return 'Укажите сумму';
  const amount = roundWalletAmountRub(value);
  if (amount < WALLET_AMOUNT_MIN_RUB) {
    return `Минимальная сумма - ${WALLET_AMOUNT_MIN_RUB.toLocaleString('ru-RU')} ₽`;
  }
  if (amount > WALLET_AMOUNT_MAX_RUB) {
    return `Максимальная сумма - ${WALLET_AMOUNT_MAX_RUB.toLocaleString('ru-RU')} ₽`;
  }
  return null;
}
